module.exports = __webpack_public_path__ + "static/img/ywlc.eea794e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ywlc.png
// module id = qKit
// module chunks = 1